module.exports = __webpack_public_path__ + "img/cover1.7c8f7d00.jpeg";